import get from 'lodash.get';
import config from '../plugins/bluejay/config';

function getHumanInquiryStatus(status) {
  let statusInHumanFormat = '';

  switch (status) {
    case this.$config.inquiryStatuses.NEW:
      statusInHumanFormat = 'New inquiry';
      break;
    case this.$config.inquiryStatuses.PENDING:
      statusInHumanFormat = 'Pending';
      break;
    case this.$config.inquiryStatuses.IN_PROGRESS:
      statusInHumanFormat = 'In progress';
      break;
    case this.$config.inquiryStatuses.SCHEDULED:
      statusInHumanFormat = 'Scheduled';
      break;
    case this.$config.inquiryStatuses.COMPLETED:
      statusInHumanFormat = 'Completed';
      break;
    case this.$config.inquiryStatuses.MATCHING_FAILED:
      statusInHumanFormat = 'Matching failed';
      break;
  }

  return statusInHumanFormat;
}

function canAdminMarkInquiryAsIdentified(inquiry) {
  const isInquiryStatusPending = inquiry.status === config.inquiryStatuses.PENDING;
  const hasIdentityVerification = get(inquiry, 'unit.active_lease_period.has_identity_verification');
  return (
    !inquiry.is_identified
    && isInquiryStatusPending
    && hasIdentityVerification
  );
}

export { getHumanInquiryStatus, canAdminMarkInquiryAsIdentified };
